module.exports = __webpack_public_path__ + "img/teeth-38.85383cad.png";